import React, { useState } from "react";
import { connect } from "react-redux";
import community from "../../Assets/plan_basic.png";
// import start from "../../Assets/plan_contact.png";
// import scale from "../../Assets/plan_enterprise.png";
import { updateProfile } from "../../Redux/actions/user";
import { addNotification } from "../../Utilities/notifications";
import keycloak from "../../keycloak";
import { plans } from "../../Utilities/plans";
import "./index.css";

function Subscriptions(props) {

    let { user } = props;
    const [values, setValues] = useState({ ...user });

    const handleClick = async (e, subscription_id) => {
        e.preventDefault();
        setValues({ ...values, subscription_id })
        let data = await updateProfile({ ...values, subscription_id }, user);
        if(data.status === 204){
             addNotification({
               title: "Techforce.ai",
               message: "Subscription has been changed successfully",
               type: "success"
             });
            props.history.push('/');
            keycloak.login()
        }
    }

    return (
      <div className="subscription-container container">
        <div className="header text-center mb-5">
          <p>TECHFORCE PLANS & PRICING</p>
          <h3 style={{lineHeight:0.2}}>Choose a plan that works for you</h3>
        </div>
        <div className="plans row">
          {plans.length > 0
            ? plans.map(obj => {             
                return (
                  <div className="plan col-3" key={obj.id}>
                    <div className="card">
                      <div className="card-body text-center">
                        <img src={community} alt="icon"></img>
                        <h5 className="card-title">{obj.name}</h5>
                        <label>{obj.price ? obj.price : "0$"}</label>
                        <p>{obj.description}</p>
                        <button
                          className="btn"
                          onClick={e => handleClick(e, obj.id)}
                          disabled={values.subscription_id === obj.id || obj.id === 0 ||obj.id === 1 || obj.id === 2 || obj.id === 3 }
                        >
                          {obj.name}
                        </button>
                      </div>
                    </div>
                    <div className="plan-features">
                      <ul>
                        <li></li>
                        <li>{obj.maximum_bots}</li>
                        <li>{obj.maximum_workers} Workers</li>
                        <li>{obj.emconsole}</li>
                        <li>{obj.support_sla}</li>
                      </ul>
                    </div>
                  </div>
                );
              })
            : null}
        </div>
      </div>
    );
}

const mapStateToProps = (state) => ({
    user: state.user
})

export default connect(mapStateToProps, null)(Subscriptions);
